module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/post-participar-lno-1203a8b7abbbac96481b1c6504393722.webp";